/**
 * 主站 Vue（web-index）托管在根路径的页面，不应触发 Next router.replace(..., { locale })，
 * 否则会变成 /en/wallet/... 等错误地址。
 *
 * 注意：user-center 自身有 /accounts/user、/accounts/assets/wallet 等 Next 路由，不可把 /accounts/* 算作 SPA 跳过。
 */
import map from "@/locales/map.json";

const nextI18nLocales = ["default", ...(map.locales || []).map((o) => o.name)];

function stripNextI18nPathForMatch(path) {
  const raw = (path || "").split("?")[0] || "";
  if (!raw || raw === "/") return "/";
  const parts = raw.split("/").filter(Boolean);
  if (parts.length && nextI18nLocales.includes(parts[0])) {
    const rest = parts.slice(1);
    return rest.length ? "/" + rest.join("/") : "/";
  }
  return raw.startsWith("/") ? raw : "/" + raw;
}

export function webIndexSpaPathNoIntlLocale(path) {
  const test = stripNextI18nPathForMatch(path);
  return (
    test.startsWith("/wallet") ||
    (test.startsWith("/account") && !test.startsWith("/accounts")) ||
    test.startsWith("/orders") ||
    test.startsWith("/user") ||
    test.startsWith("/bills")
  );
}

/** 以地址栏为准，避免无对应 page 时 router.asPath 与真实 URL 不一致 */
export function pathForVueSpaLocaleSkip(routerAsPathFallback) {
  if (typeof window === "undefined") return routerAsPathFallback || "";
  const p = window.location.pathname || "";
  const q = window.location.search || "";
  return p + q || routerAsPathFallback || "";
}
